import { useMessage } from '~/composables/common/useMessage';
import { ApiClientError } from '~/error/ApiClientError';
import { ApiServerError } from '~/error/ApiServerError';
import { ClientError } from '~/error/ClientError';
import { ForbiddenError } from '~/error/ForbiddenError';
import { UnAuthorizedError } from '~/error/UnAuthorizedError';
import { MessageCodeEnum } from '~/constants/MessageCode';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (error, instance) => {
    const loginUserStore = useLoginUserStore();
    const { showClientMessage, showApiMessage } = useMessage();
    const router = useRouter();

    // 認証/権限エラーが発生した場合は認証情報を破棄してログイン画面に戻す
    if (error instanceof UnAuthorizedError || error instanceof ForbiddenError) {
      useLogger(error.displayId).warn('API認証エラー', error);
      showApiMessage(error.displayId, error.status, error.message, () => {
        loginUserStore.$reset();
        router.push('/login');
      });
    }
    // 認証エラー以外のAPIエラー
    else if (error instanceof ApiClientError || error instanceof ApiServerError) {
      useLogger(error.displayId).error('APIエラー', error);
      showApiMessage(error.displayId, error.status, error.message);
    }
    // クライアント側で発生したエラー
    else if (error instanceof ClientError) {
      useLogger(error.displayId).error('クライアントエラー', error);
      showClientMessage(
        error.displayId,
        error.messageCode,
      );
    }
    // その他のエラー
    else {
      useLogger('0-00').error('クライアントエラー', error as Error, {
        componentName: instance?.$?.type?.__name,
        filePath: instance?.$?.type?.__file,
      });
      showClientMessage('0-00', MessageCodeEnum.UNKNOWN_ERROR);
    }
  };
});
